import axios from '../axios'

//查询本院科室字典
export const getlocalDept = (data) => {
	return axios({
	url: '/api/baseDept/localDept',
	method: 'get',
	params: data
	})
};

//查找医生列表
export const selectDoctor = (data) => {
	return axios({
	url: '/api/report/role?teamId='+data.teamId,
	method: 'post',
	data: data.weakPrivileges
	})
};

//获取医生信息
export const doctorInfo = (data) => {
	return axios({
		url: '/api/sys/user/info/'+data.id+'?t='+data.t,
		method: 'get',
		// params: data
	})
};

//更新医生账户
export const updateDoctor = (data) => {
	return axios({
	url: '/api/sys/user/update/base',
	method: 'post',
	data: data
	})
};

//医生密码修改
export const userPassword = (data) => {
	return axios({
	url: '/api/sys/user/password',
	method: 'post',
	data: data
	})
};

//留言
export const addReply = (data) => {
	return axios({
	url: '/api/difficult/add/reply',
	method: 'post',
	data: data
	})
};


//查看留言
export const findByRecodeId = (data) => {
	return axios({
	url: '/api/difficult/reply/findByRecodeId',
	method: 'get',
	params: data
	})
};



// WEBPACK FOOTER //
// ./src/http/moudules/doctor.js